import { c as _c } from "react/compiler-runtime";
import { debounce } from 'lodash';
import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useBreakpoints } from '@src/utils/breakpoints.util';

/** Use 'slide' for cards whose first image is a header band rather than the body. */
export type ArrowAlignment = 'image' | 'slide';
export const useArrowYOffset = t0 => {
  const $ = _c(14);
  const {
    arrowSize: t1,
    arrowElement,
    alignTo: t2
  } = t0;
  const arrowSize = t1 === undefined ? 40 : t1;
  const alignTo = t2 === undefined ? "image" : t2;
  const [arrowYOffset, setArrowYOffset] = useState(0);
  const {
    isMobile
  } = useBreakpoints();
  let t3;
  if ($[0] !== alignTo || $[1] !== arrowElement || $[2] !== arrowSize || $[3] !== isMobile) {
    t3 = () => {
      if (isMobile || !arrowElement) {
        return;
      }
      const sliderWrapper = arrowElement.closest("[data-slider-v2-wrapper]") as HTMLElement | null;
      const firstSlide = sliderWrapper?.querySelector(".keen-slider__slide") as HTMLElement | null;
      const target = alignTo === "slide" ? firstSlide : firstSlide?.querySelector("img, video, div[style*=\"background-image\"]") as HTMLElement | null;
      if (!sliderWrapper || !target) {
        return;
      }
      const wrapperRect = sliderWrapper.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      if (targetRect.height === 0) {
        return;
      }
      const targetTopWithinWrapper = targetRect.top - wrapperRect.top;
      const arrowYOffset_0 = targetTopWithinWrapper + targetRect.height / 2 - arrowSize / 2;
      setArrowYOffset(arrowYOffset_0);
    };
    $[0] = alignTo;
    $[1] = arrowElement;
    $[2] = arrowSize;
    $[3] = isMobile;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const calculate = t3;
  let t4;
  if ($[5] !== calculate) {
    t4 = () => {
      window.addEventListener("resize", debounce(calculate, 150));
      return () => {
        window.removeEventListener("resize", debounce(calculate, 150));
      };
    };
    $[5] = calculate;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== arrowSize || $[8] !== calculate || $[9] !== isMobile) {
    t5 = [arrowSize, calculate, isMobile];
    $[7] = arrowSize;
    $[8] = calculate;
    $[9] = isMobile;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useLayoutEffect(t4, t5);
  let t6;
  let t7;
  if ($[11] !== calculate) {
    t6 = () => {
      setTimeout(() => {
        calculate();
      }, 1);
    };
    t7 = [calculate];
    $[11] = calculate;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  return arrowYOffset;
};